/* Form Page to edit a Profile Password */
import React, { useEffect, useState } from "react"
import Alert from "react-bootstrap/Alert"
import Button from "react-bootstrap/Button"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Form from "react-bootstrap/Form"
import styles from "../../styles/Profile.module.css"
import { useHistory, useParams } from "react-router-dom"
import { axiosInstance, axiosRes } from "../../api/axiosDefaults"
import { useCurrentUser } from "../../contexts/CurrentUserContext"

import btnStyles from "../../styles/Button.module.css"
import appStyles from "../../App.module.css"
import { useRedirect } from "../../hooks/Redirect"
import toast from "react-hot-toast"
import TopBox from "../../components/TopBox"

const UserPasswordForm = () => {
  useRedirect()
  const history = useHistory()
  const { id } = useParams()
  const currentUser = useCurrentUser()

  const [userData, setUserData] = useState({
    new_password1: "",
    new_password2: "",
  })
  const { new_password1, new_password2 } = userData

  const [errors, setErrors] = useState({})

  const handleChange = (event) => {
    setUserData({
      ...userData,
      [event.target.name]: event.target.value,
    })
  }

  useEffect(() => {
    if (currentUser?.groups[0]?.name !== "Superadmin" ||
        currentUser?.groups[0]?.name !== "Admin" ||
      currentUser?.profile_id?.toString() !== id) {
      console.log("user not")
      console.log(currentUser?.groups[0]?.name)
      // history.push(`/${localStorage.getItem("projectSlug")}/signin`)
    }
  }, [currentUser, history, id])

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (!new_password1 || !new_password2) {
      toast.error("Both password fields are required.");
      return;
    }

    // Check if passwords match
    if (new_password1 !== new_password2) {
      toast.error("Passwords do not match.");
      return;
    }
    try {
      const res = await axiosInstance.post("/dj-rest-auth/password/change/", userData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        withCredentials: true,
      })
           toast.success(`Password Changed Successfully!`);
      // console.log(res.data.detail)
      if (res.error?.response?.data === undefined) {
        toast.success(`${res.data.detail}`)
        setTimeout(() => {
          history.goBack()
        }, 2000)
      } else {
        const errorData = res.error?.response?.data;
        if (errorData) {
          Object.entries(errorData).forEach(([field, messages]) => {
            messages.forEach((message) => {
              toast.error(`${field}: ${message}`)
            })
          })
        } else {
          toast.error("An unexpected error occurred.")
        }
        
      }
    } catch (err) {
      console.log(err)
      setErrors(err.response?.data)
    }
  }

  return (
    <div>
      <TopBox
        title="Change Password"
      />
      <Button
        onClick={() => history.goBack()}
        className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
      >
        Back
      </Button>
      <h5 className={`text-center py-1 ${styles.SubTitle }`}>
           CHANGE PASSWORD FORM</h5> 
      <p className={`text-center py-2 ${styles.Small }`}>PLEASE NOTE DOWN YOUR NEW PASSWORD AS AN AUTOMATIC EMAIL WITH IT IS NOT SENT</p>
    <Row>
      <Col className="py-2 mx-auto text-center" md={6}>
        <Container className={appStyles.Content}>
          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Label className={`px-0 ${styles.BoldScene}`}>New password</Form.Label>
              <Form.Control
                placeholder="new password"
                type="password"
                value={new_password1}
                onChange={handleChange}
                name="new_password1"
              />
            </Form.Group>
            {errors?.new_password1?.map((message, idx) => (
              <Alert key={idx} variant="warning">
                {message}
              </Alert>
            ))}
            <Form.Group className="mt-3">
              <Form.Label className={`px-0 ${styles.BoldScene}`}>Confirm password</Form.Label>
              <Form.Control
                placeholder="confirm new password"
                type="password"
                value={new_password2}
                onChange={handleChange}
                name="new_password2"
              />
            </Form.Group>
            {errors?.new_password2?.map((message, idx) => (
              <Alert key={idx} variant="warning">
                {message}
              </Alert>
            ))}
            <Row className="mt-3">
            <Col>
            <Button
              className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
              onClick={() => history.goBack()}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`}
            >
              Submit
            </Button>
            </Col>
            </Row>
          </Form>
        </Container>
      </Col>
    </Row>
    </div>
  )
}

export default UserPasswordForm
